import { supabase } from '../supabaseClient';

export async function checkEmployeeData(employeeNumber) {
  console.log(`Checking employee ${employeeNumber} data...\n`);

  try {
    // 1. Check if employee exists
    console.log(`Fetching employee data for: ${employeeNumber}`);
    const { data: employee, error: empError } = await supabase
      .from('employees')
      .select('*')
      .eq('employee_number', employeeNumber)
      .single();

    if (empError) {
      console.error('Error fetching employee:', empError);
      console.error('Query details:', {
        employee_number: employeeNumber,
        error: empError
      });
      return { success: false, error: empError.message };
    }

    if (!employee) {
      console.log(`❌ Employee ${employeeNumber} NOT FOUND in database`);
      return { 
        success: false, 
        error: `Employee ${employeeNumber} not found`,
        solution: 'Employee needs to be added to the database first'
      };
    }

    console.log('✅ Employee found:');
    console.log('- Name (employee_name):', employee.employee_name);
    console.log('- Name (frappe_name):', employee.frappe_name);
    console.log('- Name (short_name):', employee.short_name);
    console.log('- Number:', employee.employee_number);
    console.log('- Phone:', employee.phone || 'NOT SET');
    console.log('- Email:', employee.email || 'NOT SET');
    console.log('- Full employee data:', employee);
    console.log('');

    const result = {
      success: true,
      employee: {
        name: employee.frappe_name || employee.employee_name || employee.name || 'N/A',
        number: employee.employee_number || employee.number || 'N/A',
        phone: employee.phone || 'NOT SET',
        email: employee.email || 'NOT SET'
      },
      issues: [],
      solutions: []
    };

    // 2. Check phone number status
    if (!employee.phone) {
      result.issues.push('Phone number is not set');
      result.solutions.push('Update the employee record with their phone number in the admin dashboard');
    } else {
      // Check format
      if (!employee.phone.startsWith('+1') && !employee.phone.startsWith('1')) {
        result.issues.push('Phone number may not be properly formatted');
        result.solutions.push('Phone should be in format: +1XXXXXXXXXX or 1XXXXXXXXXX');
      }
      
      // Check if phone is properly formatted
      const cleanPhone = employee.phone.replace(/[^\d]/g, '');
      if (cleanPhone.length !== 10 && cleanPhone.length !== 11) {
        result.issues.push(`Phone number has ${cleanPhone.length} digits (should be 10 or 11)`);
        result.solutions.push('Update phone to 10 digits (without country code) or 11 digits (with country code 1)');
      }
    }

    // 3. Check if this phone number is used by another employee
    if (employee.phone) {
      try {
        console.log('Checking for phone duplicates with phone:', employee.phone);
        const { data: allEmployeesWithPhone, error: dupError } = await supabase
          .from('employees')
          .select('employee_number, frappe_name')
          .eq('phone', employee.phone);

        if (dupError) {
          console.error('Error checking phone duplicates:', dupError);
          // Don't add this as an issue since it's a query error, not a data issue
        } else if (allEmployeesWithPhone && allEmployeesWithPhone.length > 0) {
          // Filter out the current employee from the results
          const duplicates = allEmployeesWithPhone.filter(emp => emp.employee_number !== employeeNumber);
          
          if (duplicates.length > 0) {
            result.issues.push('Phone number is shared with other employees');
            result.duplicates = duplicates;
          }
        }
      } catch (error) {
        console.error('Exception while checking phone duplicates:', error);
      }
    }

    console.log('Final diagnostic result:', result);
    console.log('Employee name in result:', result.employee.name);
    return result;

  } catch (error) {
    console.error('Error:', error);
    return { success: false, error: error.message };
  }
}

// Function to update employee's phone number
export async function updateEmployeePhone(employeeNumber, phoneNumber) {
  try {
    // Clean and format the phone number
    let cleanPhone = phoneNumber.replace(/[^\d]/g, '');
    
    // Add +1 if not present and number is 10 digits
    if (cleanPhone.length === 10) {
      cleanPhone = '+1' + cleanPhone;
    } else if (cleanPhone.length === 11 && cleanPhone.startsWith('1')) {
      cleanPhone = '+' + cleanPhone;
    }

    const { data, error } = await supabase
      .from('employees')
      .update({ phone: cleanPhone })
      .eq('employee_number', employeeNumber)
      .select();

    if (error) {
      return { success: false, error: error.message };
    }

    return { 
      success: true, 
      message: `Phone updated to ${cleanPhone}`,
      data: data[0]
    };

  } catch (error) {
    return { success: false, error: error.message };
  }
}